import { render, staticRenderFns } from "./companies_page.vue?vue&type=template&id=70977219&scoped=true"
import script from "./companies_page.vue?vue&type=script&lang=js"
export * from "./companies_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70977219",
  null
  
)

export default component.exports